import { DefaultMantineColor, MantineColorsTuple, Menu, createTheme } from '@mantine/core';

const brandColor: MantineColorsTuple = [
  '#f2f8f5',
  '#e5edea',
  '#c6dbd1',
  '#a3c8b7',
  '#86b7a1',
  '#74ad93',
  '#69a98c',
  '#589478',
  '#4c836a',
  '#3b725a',
];

// Deep forest green for bold marketing statements (landing page hero/CTA
// bands) — brand[9] reads as a mid-tone accent at small sizes, not the
// near-black backdrop a full-bleed headline section needs.
const brandInkColor: MantineColorsTuple = [
  '#eef5f1',
  '#d6e6dc',
  '#aecab9',
  '#84ad96',
  '#5f9077',
  '#437761',
  '#2f5f4c',
  '#20493a',
  '#152f1d',
  '#0d1f14',
];

export const optiroTheme = createTheme({
  fontFamily: 'Sora, sans-serif',
  colors: {
    brand: brandColor,
    brandInk: brandInkColor,
  },
  primaryColor: 'brand',
  primaryShade: 9,
  components: {
    // Menus open bottom-end, so they grow out of the trigger's corner.
    Menu: Menu.extend({
      defaultProps: {
        transitionProps: { transition: 'pop-top-right' },
      },
    }),
  },
});

// Shared status vocabulary — keep in sync with StatusDot/CardBadge tone maps.
export const STATUS_COLOR: Record<
  'neutral' | 'positive' | 'attention' | 'negative',
  DefaultMantineColor
> = {
  neutral: 'gray',
  positive: 'brand',
  attention: 'orange',
  negative: 'red',
};
